import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-172">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-173" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-174">
            <div className="flex min-h-full items-center justify-center p-4" data-id="element-175">
              <motion.div initial={{
            opacity: 0,
            scale: 0.95,
            y: 20
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95,
            y: 20
          }} className="relative bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden" data-id="element-176">
                {/* Header */}
                <div className="sticky top-0 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between" data-id="element-177">
                  <h2 className="text-2xl font-bold text-slate-900" data-id="element-178">
                    Terms & Conditions
                  </h2>
                  <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full transition-colors" data-id="element-179">
                    <XIcon className="w-5 h-5 text-slate-600" data-id="element-180" />
                  </button>
                </div>

                {/* Content */}
                <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-181">
                  <section className="mb-6" data-id="element-182">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-183">
                      1. OWNERSHIP OF CONTENT
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-184">
                      All content included in the "Nail Biz Blueprint" ebook and
                      bonuses is the property of Consejos Simples. Your purchase
                      grants you a single-user license for personal use only.
                      Reselling, sharing, or redistributing this content is
                      strictly prohibited.
                    </p>
                  </section>

                  <section className="mb-6" data-id="element-185">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-186">
                      2. NO PROFESSIONAL ADVICE
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-187">
                      The information provided is for educational purposes only.
                      While we provide legal and tax guidelines for the USA, we
                      are not lawyers or certified public accountants. Consult
                      with a professional in your specific state before making
                      legal or financial decisions.
                    </p>
                  </section>

                  <section className="mb-6" data-id="element-188">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-189">
                      3. EARNINGS DISCLAIMER
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-190">
                      We make every effort to ensure that we accurately
                      represent our products. Any earnings or income statements
                      are estimates of what is possible. There is no guarantee
                      that you will earn $5,000/month. Your success depends on
                      your effort, dedication, and local market conditions.
                    </p>
                  </section>

                  <section className="mb-6" data-id="element-191">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-192">
                      4. REFUND POLICY
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-193">
                      Given the digital nature of our products, we offer a 7-day
                      money-back guarantee. If you are not satisfied, contact us
                      within 7 days of purchase for a full refund. After 7 days,
                      all sales are final.
                    </p>
                  </section>

                  <section className="mb-6" data-id="element-194">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-195">
                      5. GOVERNING LAW
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-196">
                      These terms are governed by the laws of the United States
                      of America.
                    </p>
                  </section>
                </div>
              </motion.div>
            </div>
          </div>
        </>}
    </AnimatePresence>;
}